export default "__VITE_ASSET__XfdfsWyh__"